const reader = (state = {
  id: '',
  title: '',
  author: '',
  pubDate: '',
  changeDate: '',
  numberOfPages: 0,
  chapters: [],
  body: '',
  filename: '',
  loading: false,
  progress: 0,
  tableOfContentsExpanded: false,
  downloadContextNavExpanded: false,
  downloadDialogExpanded: false,
  readyState: 'uninitialized',
  focusMode: false,
  lastPosition: 0,
  scrollPosition:0,
  isPreview:false,
  apiUrl:'',
  showSkipButton:false,
  isClientSide:false
}, { type, payload }) => {
  switch(type) {
    case 'SHOW_TOC':
      return {
        ...state,
        tableOfContentsExpanded: true
      }
    case 'HIDE_TOC':
      return {
        ...state,
        tableOfContentsExpanded: false
      }
    case 'SHOW_PDF':
      return {
        ...state,
        downloadDialogExpanded: true,
        downloadFullPdf: payload
      }
    case 'HIDE_PDF':
      return {
        ...state,
        downloadDialogExpanded: false,
        downloadFullPdf: false
      }
    case 'FETCHING_PUB':
      return {
        ...state,
        loading: true,
        readyState: 'loading',
        apiUrl: payload.apiUrl,
        id: payload.id
      }
    case 'RECEIVED_PUB':
      return {
        ...state,
        loading: false,
        readyState: 'loaded'
      }
    case 'RECEIVE_PUB':

        return {

        ...state,
        title: payload.title,
        subTitle: payload.subTitle,
        titleSubTitle: payload.pdfSubTitle,
        author: payload.author,
        pubDate: payload.publishedDate,
        updatedDate: payload.updatedDate,
        pubType: payload.publicationType,
        pubNumber: payload.publicationNumber,
        changeDate: payload.changedDate,
        numberOfPages: payload.numberOfPages,
        filename: payload.pdfFileName,
        isPreview: payload.isPreviewMode,
        showSubHeadingsInMenu:payload.showSubHeadingsInMenu,
        sections: payload.sections,
        browserPrintUrl: payload.browserPrintUrl,
        downloadUrl: payload.downloadUrl,
        readerGui: payload.readerGui,
        headings: payload.sections.map((section) => {
          return {
            heading: section.sectionHeading,
            id: section.sectionId
          }
        })
      }
    case 'SET_HEADING_POSITIONS':
      return {
        ...state,
        readyState: 'complete',
        sections: payload.map((item) => {
          return {
            ...item,
            position: item.position
          }
        })
      }
    case 'SET_ACTIVE_SECTION':
      return {
        ...state,        
        activeSectionId: payload
      }
    case 'TOGGLE_FOCUS_MODE':
      return {
        ...state,
        focusMode: !state.focusMode
      }
    case 'CHAPTER_TO_PDF':
      return {
        ...state,
        downloadPdfSrc: payload.src,
        sections: state.sections.map(
          (chapter) => chapter.sectionId === payload.id ? {...chapter, toPdf: payload.toPdf} : chapter
        )
      }
    case 'SET_SCROLL_POSITION':
      return {
        ...state,
        scrollPosition: payload
      }
    case 'INIT_CLIENTSIDE':
      return {
        ...state,
        isClientSide: true
      }
    default: return state;
  }
}

module.exports = reader;



// WEBPACK FOOTER //
// ./src/modules/reader/readerReducer.js